/* PZ Sep26: mobile (<768px) swatch scroller for collection cards (Oliver, 27 Sep; violettefr.com model). The swatch row
   spans the full card width and scrolls; when it overflows, an arrow sits on top of each end over a white fade, both arrows
   visible with the dead one dimmed; nothing when every shade fits. Arrows page the row; the selected swatch is kept in
   view clear of the fades (container scroll only, never the page). Styles: base.css ".pz-swatch-scroller".
   Desktop is untouched: the scroller is torn down above 767px. */
(function () {
  if (window.__pzSwatchScroll) return;
  window.__pzSwatchScroll = true;
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var ARROW = '<svg viewBox="0 0 9 15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7.5 1.5 1.5 7.5l6 6"/></svg>';

  function scrollerOf(picker) { return picker.querySelector('.m-product-option--content'); }

  function geom(picker) {
    var sc = scrollerOf(picker); if (!sc) return null;
    var sw = sc.querySelectorAll('.m-product-option--swatch'); if (!sw.length) return null;
    var first = sw[0], last = sw[sw.length - 1];
    var need = last.offsetLeft + last.offsetWidth - first.offsetLeft;     /* content width, independent of the end padding */
    var cs = getComputedStyle(picker);
    var nav = parseFloat(cs.getPropertyValue('--pz-nav')) || 24, fade = parseFloat(cs.getPropertyValue('--pz-fade')) || 40;
    return { sc: sc, sw: sw, overflow: need > sc.clientWidth - 2 * nav + 1, nav: nav, fade: fade };
  }

  function update(picker) {
    var g = geom(picker); if (!g) return;
    var sc = g.sc;
    picker.classList.toggle('pz-overflow', g.overflow);
    var prev = picker.querySelector('.pz-swatch-arrow--prev'), next = picker.querySelector('.pz-swatch-arrow--next');
    var max = sc.scrollWidth - sc.clientWidth;
    var canPrev = g.overflow && sc.scrollLeft > 1, canNext = g.overflow && sc.scrollLeft < max - 1;
    if (prev) { prev.disabled = !canPrev; prev.setAttribute('aria-disabled', String(!canPrev)); }
    if (next) { next.disabled = !canNext; next.setAttribute('aria-disabled', String(!canNext)); }
    picker.classList.toggle('pz-can-prev', canPrev);
    picker.classList.toggle('pz-can-next', canNext);
  }

  function scrollTo(picker, left, smooth) {
    var sc = scrollerOf(picker); if (!sc) return;
    var max = Math.max(0, sc.scrollWidth - sc.clientWidth);
    var target = Math.min(max, Math.max(0, left));
    try { sc.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { sc.scrollLeft = target; }
    setTimeout(function () { update(picker); }, smooth ? 450 : 0);
  }

  function page(picker, dir) {
    var g = geom(picker); if (!g) return;
    scrollTo(picker, g.sc.scrollLeft + dir * (g.sc.clientWidth - 2 * g.nav), true);
  }

  /* selected swatch fully visible AND outside whichever fade shows at that position; only SNAP positions are used as
     targets (proximity snapping would otherwise pull an in-between target onto the wrong swatch) */
  function revealSelected(picker, smooth) {
    var g = geom(picker); if (!g) return;
    var sc = g.sc;
    var sel = sc.querySelector('.m-product-option--node__label[data-selected="true"]');
    var node = sel && sel.closest('.m-product-option--swatch');
    if (!node || !g.overflow) { update(picker); return; }
    var base = sc.getBoundingClientRect().left - sc.scrollLeft;
    var l = node.getBoundingClientRect().left - base, r = l + node.offsetWidth, vw = sc.clientWidth, max = Math.max(0, sc.scrollWidth - vw);
    function clear(t) {
      var lf = t > 1 ? g.fade : 0, rf = t < max - 1 ? g.fade : 0;
      return l - t >= lf - 0.5 && r - t <= vw - rf + 0.5;
    }
    if (clear(sc.scrollLeft)) { update(picker); return; }
    var snaps = [0, max];
    for (var i = 0; i < g.sw.length; i++) snaps.push(Math.min(max, Math.max(0, g.sw[i].getBoundingClientRect().left - base - g.nav)));
    var best = null;
    for (var k = 0; k < snaps.length; k++) {
      if (!clear(snaps[k])) continue;
      if (best === null || Math.abs(snaps[k] - sc.scrollLeft) < Math.abs(best - sc.scrollLeft)) best = snaps[k];
    }
    scrollTo(picker, best === null ? l - g.fade : best, smooth);
  }

  function build(picker) {
    if (picker.classList.contains('pz-swatch-scroller')) return;
    var sc = scrollerOf(picker); if (!sc) return;
    picker.classList.add('pz-swatch-scroller');
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pz-swatch-arrow pz-swatch-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous shades' : 'More shades');
      b.innerHTML = ARROW;
      if (dir === 'next') b.style.transform = 'scaleX(-1)';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        page(picker, dir === 'prev' ? -1 : 1);
      });
      if (dir === 'prev') picker.insertBefore(b, picker.firstChild); else picker.appendChild(b);
    });
    sc.addEventListener('scroll', function () { update(picker); }, { passive: true });
    /* the theme marks the selected swatch asynchronously (after its product JSON fetch): follow data-selected changes */
    if ('MutationObserver' in window) {
      new MutationObserver(function () { revealSelected(picker, false); }).observe(sc, { attributes: true, subtree: true, attributeFilter: ['data-selected'] });
    }
    update(picker);
    revealSelected(picker, false);
  }

  function teardown(picker) {
    if (!picker.classList.contains('pz-swatch-scroller')) return;
    picker.querySelectorAll('.pz-swatch-arrow').forEach(function (b) { b.remove(); });
    var sc = scrollerOf(picker); if (sc) { sc.style.width = ''; sc.style.columnGap = ''; }
    picker.classList.remove('pz-swatch-scroller', 'pz-overflow', 'pz-can-prev', 'pz-can-next');
  }

  function all() { return document.querySelectorAll('#MainContent .m-product-card [data-pcard-variant-picker]'); }
  function apply() {
    var mobile = !MQ || MQ.matches;
    all().forEach(function (p) { mobile ? build(p) : teardown(p); if (mobile) update(p); });
  }

  /* after a swatch tap the theme handler runs first (on the label); then keep the ring in view */
  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.m-product-option--node__label');
    if (!label) return;
    var picker = label.closest('[data-pcard-variant-picker]');
    if (picker && picker.classList.contains('pz-swatch-scroller')) setTimeout(function () { revealSelected(picker, true); }, 30);
  });

  var t = null; function soon() { clearTimeout(t); t = setTimeout(apply, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon); else soon();
  window.addEventListener('load', soon);
  window.addEventListener('resize', soon);
  if (MQ && MQ.addEventListener) MQ.addEventListener('change', soon);
  var grid = document.querySelector('[data-product-container], .pz-col__grid');
  if (grid && 'MutationObserver' in window) new MutationObserver(soon).observe(grid, { childList: true });
})();
